import cx from "classnames";
import { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { withToast } from "../../contexts/toastr.context";
import { Button } from "../../_components/button.component";
import { ErrorDiv } from "../../_components/error.component";
import PremiumFeature from "../../_components/premium/premium-feature.component";
import { TextInput } from "../../_components/text-input.component";
import { MAIN_DOMAIN_SUFFIX } from "../../_config/helper.config";
import { setCommunity } from "../../_store/_actions/community.actions";

export const COMMUNITY_CUSTOM_DOMAIN_SETUP_PAGE_ROUTE =
  "/settings/setupcustomdomain";

function CustomDomainSetupComponent({
  user,
  community,
  communityPac,
  addToast = (e) => {},
}) {
  const [customDomain, setCustomDomain] = useState("");
  const [isValidDomain, setIsValidDomain] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <PremiumFeature isAvailable={communityPac.customDomain}>
      <div className="Card rounded shadow theme-bg-surface">
        {/* headers */}
        <div className="p-4 border-b theme-border-default lex items-start justify-between">
          <div className="font-bold theme-text-heading-2">Welcome Message</div>
          <div className="mt-2 text-sm">
            To use a custom domain for your Pensil community, please follow
            these steps.
          </div>
        </div>

        {/* Form */}

        <div className="p-4 flex flex-items-start ">
          <div className="flex place-content-center place-items-center place border-2 theme-border-default h-8 w-10 theme-text-subtitle-2 rounded-full">
            1
          </div>
          <div className="mx-4 w-full">
            <div className="flex place-items-center font-semibold theme-text-heading-2 mt-2">
              Enter your custom domain
            </div>
            <TextInput
              placeholder="Example: mydomain.example.com"
              validator={(value) => {
                if (validateDomain(value)) {
                  return null;
                } else {
                  return "Enter valid domain";
                }
              }}
              defaultValue={customDomain}
              className="py-2 focus:outline-none theme-bg-default"
              onChange={(value) => {
                setCustomDomain(value);
                // set address
              }}
            />
          </div>
        </div>

        {/* Readonly HOST/NAME */}
        <div className="flex p-4 flex-items-start">
          <div className="flex  place-content-center  place-items-center place border-2 theme-border-default h-8 w-12 theme-text-subtitle-2 rounded-full">
            2
          </div>
          <div className="mx-4">
            <div className="flex place-items-center font-semibold theme-text-heading-2 mt-2">
              Set up a CNAME record in your DNS provider
            </div>
            <div className="theme-text-subtitle-1 mt-2">
              To configure your custom domain, you’ll need to add a CNAME record
              pointing your custom domain to your Circle subdomain in your DNS
              provider.
            </div>

            <div className="grid grid-cols-5 border theme-border-default mt-4">
              <div className="col-span-1 py-1 px-2 text-sm theme-text-subtitle-1 border-b border-r theme-border-default">
                Type
              </div>
              <div className="col-span-2 py-1 px-2 text-sm theme-text-subtitle-1 border-b border-r theme-border-default">
                Host/Name
              </div>
              <div className="col-span-2 py-1 px-2 text-sm theme-text-subtitle-1 border-b theme-border-default">
                Target/Value
              </div>

              <div className="col-span-1 text-base py-1 px-2  theme-text-subtitle-1 border-r theme-border-default">
                CNAME
              </div>
              <div
                className={cx(
                  "col-span-2 py-1 px-2 text-sm  overflow-auto  border-r theme-border-default",
                  {
                    "theme-text-subtitle-2": !isValidDomain,
                    "theme-text-subtitle-1": isValidDomain,
                  }
                )}>
                {isValidDomain ? hostname() : "mydomain.example.com"}
              </div>
              <div className="col-span-2 text-base py-1 px-2  theme-text-subtitle-1  border-r theme-border-default">
                community{MAIN_DOMAIN_SUFFIX}
              </div>
            </div>

            <div className="mt-2"></div>
            <Link
              to="https://www.google.com/search?q=cname+record+in+dns+provider"
              onClick={(e) => {}}
              className="flex items-center mt-6 ">
              → Use this tool to validate the CNAME record
            </Link>
            <Link
              to="https://www.google.com/search?q=cname+record+in+dns+provider"
              onClick={(e) => {}}
              className="flex items-center mt-3 ">
              → Check out our guide if you need help
            </Link>
          </div>
        </div>

        {/* Form Ends */}

        <div className="card p-5 pt-0 theme-text-heading-2 mt-2 ">
          {/* submit button */}
          <Button
            className="w-full py-2 mt-5"
            onClick={() => {
              // check if form can be submitted
              setIsLoading(true);
            }}
            isLoading={isLoading}
            label="Setup Domain"
          />
          <ErrorDiv error={errorMessage} />
        </div>
      </div>
    </PremiumFeature>
  );
  function validateDomain(value) {
    if (
      /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(
        value
      )
    ) {
      setIsValidDomain(true);
      return true;
    } else {
      setIsValidDomain(false);
      return false;
    }
  }

  function hostname() {
    if (
      customDomain &&
      customDomain !== "" &&
      isValidDomain &&
      customDomain.includes(".")
    ) {
      return customDomain.split(".")[0];
    }
    return null;
  }
}

const CustomDomainSetupPage = withToast(
  connect(
    (s) => ({
      user: s.auth,
      community: s.community,
      communityPac: s.communityPac,
    }),
    (d) =>
      bindActionCreators(
        {
          onCommunityUpdate: setCommunity,
        },
        d
      )
  )(CustomDomainSetupComponent)
);

export default CustomDomainSetupPage;
